import { useConfigSlice } from '../store/slices/config/selectors';
import { useGameStateSlice } from '../store/slices/game/selectors';

export const useNetPositionConnected = (): number | undefined => {
  const compliance = useConfigSlice.compliance();
  const hideNetPositionInitial = useConfigSlice.casinoConfig()?.forceHideNetPosition;
  const hideNetPosition = hideNetPositionInitial === undefined ? false : hideNetPositionInitial;
  const netPosition = !!(compliance?.netPosition && !hideNetPosition);
  const net = useGameStateSlice.getNetPosition();

  return netPosition ? net : undefined;
};
